import CartModal from './CartModal'

export default CartModal
